/*exported module*/
// eslint-disable-next-line no-unused-vars
var module = angular.module('sdCompanyProfileModule', []);
